import { createSlice } from '@reduxjs/toolkit'
import _ from 'lodash'

const initialState = {
  page: 0,
  keyword: '',
  option1: '',
  option2: null,
  menu: null,
}

const paginationSlice = createSlice({
  name: 'pagination',
  initialState: _.cloneDeep(initialState),
  reducers: {
    clearPagination: (state) => {
      state.page = initialState.page
      state.keyword = initialState.keyword
      state.option1 = initialState.option1
      state.menu = initialState.menu
    },
    initPagination: (state, { payload }) => {
      if (state.menu !== payload) {
        state.page = initialState.page
        state.keyword = initialState.keyword
        state.option1 = initialState.option1
        state.menu = payload
      }
    },
    setPagination: (state, { payload }) => {
      for (let key in payload) {
        state[key] = payload[key]
      }
    },
  },
})

export const paginationAction = paginationSlice.actions

export default paginationSlice.reducer
